import { FC } from "react";
import { Skeleton } from "@/components/ui/skeleton";

const ContractUpdateSkeleton: FC = () => {
  return (
    <div className="flex flex-col gap-8">
      <div className="flex items-center justify-between">
        <Skeleton className="h-8 w-40" />
        <Skeleton className="h-9 w-32 rounded-md" />
      </div>

      <Skeleton className="h-7 w-3/4 mx-auto" />

      <div className="space-y-3">
        <Skeleton className="h-4 w-1/3" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-5/6" />
      </div>

      <div>
        <Skeleton className="h-5 w-48 mb-3" />
        <div className="space-y-3">
          <div className="flex items-center justify-between py-2 border-b">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-4 w-20" />
          </div>
          <div className="flex items-center justify-between py-2 border-b">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-4 w-20" />
          </div>
          <div className="flex items-center justify-between py-2">
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-4 w-24" />
          </div>
        </div>
      </div>

      <div>
        <Skeleton className="h-5 w-64 mb-3" />
        <div className="space-y-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-2/3" />
        </div>
      </div>

      <div className="flex gap-6">
        <Skeleton className="h-12 flex-1 rounded-md" />
        <Skeleton className="h-12 flex-1 rounded-md" />
      </div>

      <div className="flex items-center justify-center gap-3">
        <Skeleton className="h-4 w-40" />
        <Skeleton className="h-9 w-28 rounded-md" />
      </div>
    </div>
  );
};

export default ContractUpdateSkeleton;
